import React, { Fragment, useEffect, useRef } from "react";
import { FormBuilderFormHint } from "../common/hint/form-builder-form.hint";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
import { useFormData } from "../../../../hooks/client/use-form-data";
const FormBuilderFormInterfaceDropdown = ({ item, t }) => {
  if (!item) return null;
  const selectRef = useRef();
  const { formDataSetters, formData } = useFormData();
  const { label, select, p: hint } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  const defaultValue = formData == null ? void 0 : formData[select.name];
  useEffect(() => {
    formDataSetters.setInputValue(select.name, selectRef.current.value);
  }, [select.name]);
  return /* @__PURE__ */ React.createElement("div", { className: item.class }, /* @__PURE__ */ React.createElement("label", { htmlFor: label.for }, t(label.nodeValue)), /* @__PURE__ */ React.createElement(
    "select",
    {
      ref: selectRef,
      id: select.id,
      name: select == null ? void 0 : select.name,
      defaultValue,
      required: select == null ? void 0 : select.required,
      "aria-describedby": select["aria-describedby"]
    },
    select.elements.map((el, index) => {
      if (el.nodeName === "option") {
        return /* @__PURE__ */ React.createElement(Fragment, { key: index }, /* @__PURE__ */ React.createElement("option", { value: el.value }, t(el.nodeValue)));
      }
    })
  ), /* @__PURE__ */ React.createElement(FormBuilderFormHint, { item: t(hint == null ? void 0 : hint.nodeValue), id: hint == null ? void 0 : hint.id }));
};
FormBuilderFormInterfaceDropdown.displayName = "FormBuilderFormInterfaceDropdown";
export default React.memo(FormBuilderFormInterfaceDropdown);
